import { useContext } from 'react';
import { ConfigContext } from '@common/Config';
import { applyParameters } from '@common/Core/helpers/route';

const useRouteFormatter = () => {
    const config = useContext(ConfigContext);
    const { language, store } = config;

    return (route, parameters = {}) => applyParameters(route, { ...parameters, store, language })
        .replace(/{(.*?)}/g, ':$1');
};

export default useRouteFormatter;
